import type { EventHint, ErrorEvent } from "@sentry/types";

import { abortError } from "../filters/abortError/abortError";
import { agentInjection } from "../filters/agentInjection/agentInjection";
import { batBeacon } from "../filters/batBeacon/batBeacon";
import { chunkLoadError } from "../filters/chunkLoadError/chunkLoadError";
import { inAppBrowserBridge } from "../filters/inAppBrowserBridge/inAppBrowserBridge";
import { mapboxGlUnproject } from "../filters/mapboxGlUnproject/mapboxGlUnproject";
import { objectMatchingId } from "../filters/objectMatchingId/objectMatchingId";
import { resizeObserverLoop } from "../filters/resizeObserverLoop/resizeObserverLoop";
import { thirdPartyDomains } from "../filters/thirdPartyDomains/thirdPartyDomains";
import { errorsTurnedOffFilter } from "../filters/turnErrorsOff/turnErrorsOff";
import { webkitMessageHandlers } from "../filters/webkitMessageHandlers/webkitMessageHandlers";

const filters = {
  agentInjection,
  abortError,
  batBeacon,
  chunkLoadError,
  mapboxGlUnproject,
  thirdPartyDomains,
  objectMatchingId,
  resizeObserverLoop,
  errorsTurnedOffFilter,
  webkitMessageHandlers,
  inAppBrowserBridge,
};

export const beforeSend = (event: ErrorEvent, hint: EventHint) => {
  for (const filter of Object.values(filters)) {
    const result = filter(event, hint);
    if (!result) return null;
  }

  return event;
};
